/* fh-card-films [CUSTOM] (kriti-1009:card-film, Kriti's sheet row 9). Plays a card's product film, muted and
   looping, only while the card is on screen, and pauses it off screen or in a hidden tab. Reduced motion, data saver and
   browsers without IntersectionObserver keep the still. Loaded next to each film by snippets/fh-card-film.liquid, so it
   guards itself to run once. The film fades in on its first real frame (CSS .is-on), so a slow load never flashes. */
(function () {
  if (window.__fhFilms) return;
  window.__fhFilms = true;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  /* polish-1019:films_defer: also slow connections keep the still */
  var conn = navigator.connection;
  var save = conn && (conn.saveData || /2g|3g/.test(conn.effectiveType || ''));
  if (reduce || save || !('IntersectionObserver' in window)) return;

  function play(v) {
    if (!v.getAttribute('src')) v.setAttribute('src', v.getAttribute('data-src'));
    var p = v.play();
    if (p && p.catch) p.catch(function () {});
  }
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      var v = e.target;
      v.__fhIn = e.isIntersecting && e.intersectionRatio >= 0.35;
      if (v.__fhIn && !document.hidden) play(v);
      else if (!v.paused) v.pause();
    });
  }, { threshold: [0, 0.35] });

  function bind(v) {
    if (v.__fhBound) return;
    v.__fhBound = true;
    v.muted = true; /* iOS reads the property, not only the attribute */
    v.addEventListener('playing', function () { v.classList.add('is-on'); });
    v.addEventListener('error', function () {
      /* the 480p map is stale for this film: fall back to the file Liquid knows, once */
      var alt = v.getAttribute('data-alt');
      if (alt && v.getAttribute('src') !== alt) { v.setAttribute('src', alt); if (v.__fhIn) play(v); }
    });
    io.observe(v);
  }
  function scan() { [].forEach.call(document.querySelectorAll('video[data-fh-film]'), bind); }

  /* polish-1019:films_defer: start once the page has loaded, so a film in the first screen never competes with the page's own images */
  function start() { setTimeout(scan, 800); }
  if (document.readyState === 'complete') start(); else window.addEventListener('load', start);
  document.addEventListener('shopify:section:load', scan);
  document.addEventListener('visibilitychange', function () {
    [].forEach.call(document.querySelectorAll('video[data-fh-film]'), function (v) {
      if (document.hidden) { if (!v.paused) v.pause(); }
      else if (v.__fhIn) play(v);
    });
  });
})();
